<template>
    <div class="saph-server-container">

        <!-- Mobile Version -->
        <div class="saph-server-content-container">

            <div class="content-top-row">
                <div style="display: flex; align-items: center; justify-content: flex-start;">
                    <v-avatar style="margin-right: 1rem;">
                        <img :src="image" alt="alt">
                    </v-avatar>

                    <h3>{{title}}</h3>
                </div>

                <img style="cursor: pointer;" class="saph-server-button" :src="buttonImg" alt="Discord Logo" v-on:click="goToLink()">
            </div>

            <div class="saph-server-text-container">
                <p style="margin-top: .5rem;">{{description}}</p>
            </div>
        </div>

        <!-- Desktop Version -->
        <div class="saph-server-desktop-content-container">
            <h3>{{title}}</h3>
            <img :src="image" alt="alt" style="height: auto; width: 50%; max-width: 180px; border-radius: 150px; margin: 1rem 0;">
            <p style="font-size: 14px; width: 100%; text-align: center; margin: 0;">{{description}}</p>

            <div class="saph-server-action-box">
                <v-card
                        ripple
                        :elevation="userIsDesktop ? 3 : 0"
                        class="saph-server-button"
                        v-bind:style="{backgroundColor: buttonColor}"
                        v-on:click="goToLink()"
                >
                    <b v-if="userIsDesktop" style="font-size: 16px;">Discord</b>
                </v-card>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'SaphServer',

    props: {
        title: String,
        description: String,
        image: String,
        bType: String,
        url: String
    },

    created() {
        this.userIsDesktop = window.matchMedia('(min-width: 1000px)').matches
    },

    mounted() {

        let buttonType;
        if (this.bType in this.buttonColors){
            buttonType = this.bType
        } else {
            buttonType = "other"
        }
        this.buttonColor = this.buttonColors[buttonType]
        this.buttonImg = this.buttonImages[buttonType]
    },

    updated() {
        this.userIsDesktop = window.matchMedia('(min-width: 1000px)').matches
    },

    methods: {
        goToLink: function () {
            window.open(this.url)
        }
    },

    data: () => ({

        userIsDesktop: false,

        buttonImg: "",
        buttonColor: "#7289DA",

        buttonColors: {
            "discord": "#7289DA",
            "slack": "#4A154B",
            "other": "#649347"
        },
        buttonImages: {
            "discord": "/assets/discordlogowhite.svg",
            "slack": "/assets/slack-mark.svg",
            "other": "@/assets/discordlogowhite.svg"
        },
    }),
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-size: 20px;
        margin: 0;
    }

    p {
        font-size: 13px;
        margin: 0;
    }

    span {
        font-size: 10px;
    }

    .saph-server-container {
        height: fit-content;
        width: 100%;

        display: grid;
        grid-template-columns: 3fr;
        justify-content: center;
        align-items: start;

        padding: 16px 16px;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
        border-radius: 5px;

        background-color: #404040;
        margin-bottom: 1rem;
    }

    .saph-server-content-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        overflow-x: hidden;
        text-overflow: clip;
    }

    .content-top-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .saph-server-action-box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        height: 100%;
    }

    .saph-server-text-container {
        min-width: 100%;
        height: fit-content;
    }

    .saph-server-button {
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .saph-server-button:hover {
        cursor: pointer;
    }

    .saph-server-button-icon {
        width: 80%;
    }

    .saph-server-desktop-content-container {
        display: none;
    }

    @media screen and (min-width: 1000px) {

        .saph-server-content-container {
            display: none;
        }

        .saph-server-container {

            height: auto;

            width: 100%;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            padding: 16px;
        }

        .saph-server-desktop-content-container {
            height: 100%;
            width: 100%;

            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            margin-bottom: 10px;
        }

        .saph-server-action-box {
            height: 45px;
            width: 80%;
            margin-top: 1rem;
        }

        .saph-server-button {
            height: 90%;
            width: 100%;
        }
    }
</style>
